<template>
  <TextInput v-model="valueModel" type="number" v-bind="$attrs" />
</template>

<script>
import valueModel from '@/mixins/valueModel';
import TextInput from '@/components/atoms/form/HeraFormTextInput';

export default {
  name: 'NumberInput',
  components: {
    TextInput,
  },
  mixins: [valueModel],
};
</script>
